import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { LoadExcelFiles } from "@/helpers/excel-manager";
import { FlowDetailsController } from '@/components/FlowDetails.vue';
import { flows } from '@/helpers/APIconnection';
import { globalProperties } from '@/main.js';
import store from '@/store.js';
export const FlowsController = {
  LaunchFlow: async function (data) {
    // flowInputs, flowId, sendOutputToServer

    const response = await globalProperties.$desktopAppComunication("LaunchFlow", data);
    if (response) {
      return FlowDetailsController.NormalizeLogData(response);
    }
    return response;
  },
  Schedule: async function ({
    flowId,
    flowInputs,
    machine,
    repeat,
    interval,
    every,
    scheduledDate = new Date(),
    localProcess,
    showScheduledMessage = true,
    // Show message when scheduled
    processName,
    // Custom name of the scheduled process
    localMachineHashCode
  }) {
    if (!machine || Array.isArray(machine) && !machine.length) {
      if (globalProperties.$embedded) localMachineHashCode = await globalProperties.$desktopAppComunication("GetMachineHashCode");else {
        globalProperties.$howToRemoteOnboarding();
      }
    }
    const body = {
      localProcess
    };

    // Machine checking >>

    if (machine && machine._id) {
      body.machine = machine._id;
    } else if (localMachineHashCode) {
      body.localMachineHashCode = localMachineHashCode;
    } else {
      globalProperties.$createToastMessage({
        text: 'No se ha podido programar este robot, es necesario sincronizar tu dispositivo',
        type: 'error',
        close: false,
        fixed: true,
        alive: 5000
      });
      return;
    }

    // Normalize scheduling >>

    if (repeat) {
      Object.assign(body, {
        repeat,
        interval,
        every
      });
    }
    if (scheduledDate instanceof Date) {
      body.scheduledDate = scheduledDate.toISOString();
    } else {
      body.scheduledDate = scheduledDate;
    }

    // Normalize arguments >>

    const normalizedArguments = {
      ...flowInputs
    };
    Promise.all(Object.entries(normalizedArguments).map(async arg => {
      if (Array.isArray(arg[1]) && arg[1].some(value => value instanceof File && /(?<=^|\W)\.xlsx(?=$|\W)/.test(value.name))) {
        const data = await LoadExcelFiles(arg[1], 'aoo');
        const flatted = data.flatMap(file => file.data);
        arg[0] = {
          type: 'list',
          value: flatted
        };
      }
    }));
    body.flowInputs = normalizedArguments;
    const response = await flows.schedule(flowId ? '/' + flowId : '', body);
    if (response?.status === 200) {
      store.state.AutopilotGetSchedulesNow?.();
      if (showScheduledMessage) {
        store.state.ui.promptModal = {
          bully: false,
          onclose: () => store.state.ui.promptModal = undefined,
          footer: [{
            variant: 'outlined',
            ...store.state.externalAccess,
            afterClick: () => store.state.ui.promptModal = undefined
          }, {
            click: () => store.state.ui.promptModal = undefined,
            text: 'Entendido!',
            variant: 'primary'
          }]
        };
        if (machine) {
          store.state.ui.promptModal.title = '<i class=icon-mr-robot></i> Robot añadido a la cola';
          store.state.ui.promptModal.text = `Se ha programado el robot <span class=font-semibold>${processName || '-'}</span> en <span class=font-semibold>${machine.name || '-'}</span>`;
        } else {
          store.state.ui.promptModal.title = '<i class=icon-mr-robot></i> Robot programado';
          store.state.ui.promptModal.text = `Se lanzará con el piloto automático activo el <span class=font-semibold>${globalProperties.$formatDate({
            date: scheduledDate,
            format: '{day2}/{month2} a las hh:mm'
          })}</span>`;
        }
      }
    } else {
      globalProperties.$createToastMessage({
        text: 'No se ha podido programar este robot',
        type: 'error',
        close: false,
        fixed: true,
        alive: 3000
      });
    }
    return response;
  }
};
export default {
  data: function () {
    return {
      flowsList: undefined,
      selectedFlow: undefined,
      loading: {},
      flowsSearchKeyword: undefined
    };
  },
  created() {
    this.GetFlows();
  },
  computed: {
    GetNormalizedFlowsByGroup() {
      if (!this.Flows) return;
      const groups = {};
      this.Flows?.forEach(f => {
        if (f.group?._id in groups) {
          groups[f.group._id].flows.push(f);
        } else {
          groups[f.group._id] = f.group;
          f.group.flows = [f];
        }
      });
      return groups;
    },
    Flows() {
      if (!this.flowsList) return;
      if (this.flowsSearchKeyword) {
        return this.flowsList.filter(f => ((f.group?.name ?? '').toLowerCase() + f.name.toLowerCase()).replaceAll(' ', '').includes(this.flowsSearchKeyword.toLowerCase().replaceAll(' ', '')));
      }
      return this.flowsList;
    },
    previousSelectedFlow() {
      return this.$route.params.id;
    }
  },
  watch: {
    selectedFlow() {
      if (!this.selectedFlow) this.$router.push({
        ...this.$route,
        params: {}
      });
    },
    previousSelectedFlow: {
      handler() {
        if (this.previousSelectedFlow) {
          this.GetSelectedFlowData(this.previousSelectedFlow);
        } else this.selectedFlow = undefined;
      },
      immediate: true
    }
  },
  methods: {
    GetFlows: async function () {
      // >> Get flows from database

      this.loading.flows = true;
      const response = await flows.get();
      if (response?.status === 200) {
        this.flowsList = response.data;
      }
      const types = {};
      this.flowsList?.forEach(f => f.flowInputs?.forEach(i => types[i.type] = true));
      this.loading.flows = false;
    },
    FlowSectionBuilder: function (inputs) {
      if (!inputs?.length) return [];
      const builder = Object.values(Object.groupBy(inputs, ({
        template
      }) => {
        if (template === 'FormToFlowConfig') return '2';
        return '1';
      }));
      builder[builder.length - 1].execution = true;
      return builder.map((section, index) => {
        return {
          template: 'InputComponents',
          builder: section,
          execution: index === builder.length - 1,
          scheduler: true
        };
      });
    },
    OnFlowSelect: function (id) {
      if (id) {
        this.$router.replace({
          ...this.$route,
          params: {
            id
          }
        });
      }
    },
    GetSelectedFlowData: async function (id) {
      if (!id) return;
      this.loading.loadingFlowData = true;
      const response = await flows.getById(id);
      if (response?.status === 200 && response.data) {
        this.selectedFlow = response.data;
      } else if (this.previousSelectedFlow) {
        this.$router.replace({
          ...this.$route,
          params: {}
        });
        this.loading.loadingFlowData = false;
        return;
      }
      if (!this.selectedFlow.template) this.GetFlowTemplate(this.selectedFlow.id);
      this.loading.loadingFlowData = false;
      this.$state.flowLauncherController = {
        flow: {
          ...this.selectedFlow,
          sectionSetup: {
            builder: this.FlowSectionBuilder(this.selectedFlow.flowInputs)
          }
        }
      };
    },
    GetFlowTemplate: async function (id) {
      const response = await flows.getTemplateByID(id);
      if (response?.status === 200 && response.data) this.selectedFlow.template = response.data;
    },
    // ==========| Launch Flow controller |==========

    OnLaunchFlow: async function (params) {
      const remoteMachineSelected = this.RemoteCertificateMachineSelected(params.inputs);
      const data = {
        flowInputs: params.arguments,
        flowId: this.selectedFlow.id
      };
      if (params.schedule || remoteMachineSelected || !this.$embedded) {
        data.processName = this.selectedFlow.name;
        if (params.schedule) {
          Object.assign(data, params.schedule);
        }
        if (remoteMachineSelected) {
          data.machine = remoteMachineSelected;
        } else if (!this.$embedded) {
          // Machine selector management for flows without certificates selector, temporal until improvements

          let machineResolve;
          const machinePromise = new Promise(r => machineResolve = r);
          this.requiredMachineModal = {
            // title: 'Selecciona en qué máquina quieres sincronizar',
            // userResourcesManager: { selectable: true, type: 'machines', multiple: false, includeLocalMachine: true },
            footer: [{
              text: this.$st('general.cancel'),
              variant: 'outlined',
              click: () => machineResolve(false)
            }, {
              text: this.$st('general.continue'),
              click: () => machineResolve(this.requiredMachineModal.machine)
            }]
          };
          const machineResponse = await machinePromise;
          this.requiredMachineModal = undefined;
          if (machineResponse) {
            data.machine = machineResponse;
          } else return;
        }
        await FlowsController.Schedule(data);
      } else {
        data.emailConfiguration = params.emailConfiguration;
        const response = await FlowsController.LaunchFlow(data);
        this.$addRobotLogNotification(response);
      }
    },
    RemoteCertificateMachineSelected: function (inputs = {}) {
      const certificateInput = Object.values(inputs).find(i => i.hasShared);
      return certificateInput?.value?.find(v => v.machine)?.machine;
    }
  }
};